import { AfterViewChecked, Directive, ElementRef, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { CalendarFlorderInfo } from 'app/core/store/calendar/common/calendar.interface';
import { ContractInfo } from 'app/core/store/contract-info/contract-info.interface';
import { initialState as emptyContractInfo } from 'app/core/store/contract-info/contract-info.model';
import { Definitions } from 'app/core/store/definitions/definitions.interface';
import { BaseContainer } from 'app/modules/base/BaseContainer';
import { PanelStatus } from 'app/modules/florder/florder-edit-container/florder-edit.interface';
import { distinctUntilChanged, map, takeWhile } from 'rxjs/operators';

@Directive()
export abstract class AbstractCalendarFlorderTooltipContainer extends BaseContainer implements OnInit, AfterViewChecked {
  @Input() florderInfo: CalendarFlorderInfo;

  @Output() boundingBoxChange = new EventEmitter<DOMRectInit>();

  definitions: Definitions;
  contractInfo: ContractInfo = emptyContractInfo;
  panelStatus: PanelStatus;
  private boundingRect: DOMRectInit;
  private host: ElementRef = inject(ElementRef);

  ngOnInit() {
    this.store
      .pipe(
        takeWhile(() => !this.destroyed),
        map(state => state.definitions),
        distinctUntilChanged()
      )
      .subscribe(definitions => {
        this.definitions = definitions;
      });

    // Get orderDetail
    this.getFlorderFromStore();
    // Load orderDetail
    this.loadFlorder();

    this.panelStatus = {
      blockIsVisible: true,
      busy: false,
      createTemplate: false,
      editTemplate: false,
      isEdit: false,
      isEditable: false,
      // isFlowEdit: false,
      // isHandshaker: false,
      isNew: false,
      isUpdate: false,
      isView: true,
      isVisible: true,
      opening: false,
      saving: false,
    };
  }

  ngAfterViewChecked(): void {
    this.checkBoundingRectChange();
  }

  private checkBoundingRectChange() {
    const boundingRect = this.host.nativeElement.getBoundingClientRect();
    if (boundingRect === null && this.boundingRect === null) {
      return;
    }
    let changed;
    changed = (boundingRect == undefined) !== (this.boundingRect == undefined);
    changed = changed || boundingRect.x !== this.boundingRect.x;
    changed = changed || boundingRect.y !== this.boundingRect.y;
    changed = changed || boundingRect.width !== this.boundingRect.width;
    changed = changed || boundingRect.height !== this.boundingRect.height;
    if (changed) {
      this.boundingRect = boundingRect;
      this.boundingBoxChange.emit(boundingRect);
    }
  }

  protected abstract getFlorderFromStore();

  protected abstract loadFlorder();
}
